import { createFileRoute, redirect } from '@tanstack/react-router';
import { TEAM_PAGE_TAB } from '@/components/organisms/settings-call/call-settings-tabs';

// Links from the short-lived team-wide pages: each now lives on a tab.
export const Route = createFileRoute('/_dashboard/dashboard/settings/call-settings/team/$section')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/settings/call-settings',
      search: { tab: TEAM_PAGE_TAB[params.section] ?? 'general' },
    });
  },
});
